/* eslint-disable */
import React, { useEffect, useRef, useState } from "react";
import { Button, Select, TextInput } from "@mantine/core";
import flat from "flat";
import { BeatLoader } from "react-spinners";
import { DatePicker } from "@mantine/dates";
import {
  differenceInMonths,
  differenceInYears,
  differenceInDays,
  addYears,
  addMonths,
  addDays,
  parseISO,
  subDays,
  formatISO,
} from "date-fns";
import {
  formatToIndianNumbering,
  loadingStates,
} from "../../utilities/utilities";
import colors from "../../utilities/design";
import { showNotification } from "@mantine/notifications";
import { getBussinessUnit } from "../../utilities/apis/serviceProvider";
import { apiWrapWithErrorWithData } from "../../utilities/apiHelpers";
import { getBuList } from "../../utilities/apis/users";
import { Group, ThemeIcon, Title, Text, ActionIcon } from "@mantine/core";

import { IconCalendarEvent, IconReload } from "@tabler/icons-react";

export const INDIA_STATES_UNIONS = [
  { label: "Andhra Pradesh", value: "Andhra Pradesh" },
  { label: "Karnataka", value: "Karnataka" },
  {
    label: "Andaman and Nicobar Islands",
    value: "Andaman and Nicobar Islands",
  },
  { label: "Arunachal Pradesh", value: "Arunachal Pradesh" },
  { label: "Assam", value: "Assam" },
  { label: "Bihar", value: "Bihar" },
  { label: "Chandigarh", value: "Chandigarh" },
  { label: "Chattisgarh", value: "Chattisgarh" },
  { label: "Dadra and Nagar Haveli", value: "Dadra and Nagar Haveli" },
  { label: "Daman and Diu", value: "Daman and Diu" },
  { label: "Delhi", value: "Delhi" },
  { label: "Goa", value: "Goa" },
  { label: "Gujarat", value: "Gujarat" },
  { label: "Haryana", value: "Haryana" },
  { label: "Himachal Pradesh", value: "Himachal Pradesh" },
  { label: "Jammu and Kashmir", value: "Jammu and Kashmir" },
  { label: "Jharkhand", value: "Jharkhand" },
  { label: "Kerala", value: "Kerala" },
  { label: "Lakshadweep Islands", value: "Lakshadweep Islands" },
  { label: "Madhya Pradesh", value: "Madhya Pradesh" },
  { label: "Maharashtra", value: "Maharashtra" },
  { label: "Manipur", value: "Manipur" },
  { label: "Meghalaya", value: "Meghalaya" },
  { label: "Mizoram", value: "Mizoram" },
  { label: "Nagaland", value: "Nagaland" },
  { label: "Odisha", value: "Odisha" },
  { label: "Pondicherry", value: "Pondicherry" },
  { label: "Punjab", value: "Punjab" },
  { label: "Rajasthan", value: "Rajasthan" },
  { label: "Sikkim", value: "Sikkim" },
  { label: "Tamil Nadu", value: "Tamil Nadu" },
  { label: "Telangana", value: "Telangana" },
  { label: "Tripura", value: "Tripura" },
  { label: "Uttar Pradesh", value: "Uttar Pradesh" },
  { label: "Uttarakhand", value: "Uttarakhand" },
  { label: "West Bengal", value: "West Bengal" },
];

const AgreementForm2 = ({
  id,
  form,
  setUiConfigs,
  uiConfigs,
  save,
  initialState,
}) => {
  const agreementFormJson = flat.unflatten(form.values);
  console.log({ agreementFormJson });
  const [businessUnitsOptions, setBusinessUnitsOptions] = useState([]);
  const [inputMode, setInputMode] = useState(null);
  const modeInitialized = useRef(false);

  useEffect(() => {
    const fetchBusinessUnits = async () => {
      try {
        const response = await apiWrapWithErrorWithData(getBuList());
        console.log("response: ", response);
        if (response.success) {
          const formattedData = response.result.map(({ id, name }) => ({
            value: id.toString(),
            label: name,
          }));
          setBusinessUnitsOptions(formattedData);
        }
      } catch (error) {
        console.error("Error fetching business units:", error);
      }
    };
    fetchBusinessUnits();
  }, []);

  const reminderLabels = {
    15: "15 days",
    30: "30 days",
    45: "45 days",
    60: "60 days",
  };

  const fieldStyles = {
    input: {
      height: 44,
    },
    label: {
      fontWeight: 500,
      marginBottom: 6,
    },
    error: {
      fontSize: 12,
      textTransform: "none",
    },
  };

  const validate = () => {
    const keys = {};
    if (
      !agreementFormJson.dateOfContract ||
      isNaN(parseISO(agreementFormJson.dateOfContract).getTime())
    ) {
      keys["dateOfContract"] = "Please select a start date.";
    }

    // if(!agreementFormJson.location) {
    //   keys['location'] = 'Please enter location.';
    // }
    if (!agreementFormJson.businessUnit) {
      keys["businessUnit"] = "Please select a business unit.";
    }

    if (!hasDuration && !hasEndDate) {
      keys.noOfYears = "Please enter a valid duration or end date.";
      keys.dueDateOfContract = "Please enter a valid duration or end date.";
    }

    // End date must be > starting date
    if (
      !hasEndDate &&
      Number(agreementFormJson.noOfYears || 0) <= 0 &&
      Number(agreementFormJson.noOfMonths || 0) <= 0 &&
      Number(agreementFormJson.noOfDays || 0) <= 0
    ) {
      keys.noOfYears = "Please enter a valid year";
      keys.noOfMonths = "Please enter a valid month";
      keys.noOfDays = "Please enter a valid day";
    }

    if (Object.keys(keys).length !== 0) {
      form.clearErrors();
      form.setErrors(keys);
      showNotification({
        color: "red",
        title: "Validation Error",
        message: "Please complete all mandatory fields before continuing.",
        autoClose: 3000,
      });
    }
    return Object.keys(keys).length === 0;
  };

  const savePrev = async () => {
    if (true) {
      setUiConfigs({
        ...uiConfigs,
        currentStep: 0,
      });
    }
  };

  const saveNext = async () => {
    if (validate()) {
      await save({ ...form.values });
      setUiConfigs({
        ...uiConfigs,
        currentStep: 2,
      });
      // navigate(`/app/agreements/details/${id}`);
    }
  };

  const handleChange = (e) => {
    const inputValue = e.target.value.replace(/,/g, ""); // Remove commas
    const numericValue = parseInt(inputValue, 10); // Convert to integer

    if (!isNaN(numericValue)) {
      form.setFieldValue("agreementValue", numericValue);
    } else {
      form.setFieldValue("agreementValue", 0);
    }
  };

  const hasDuration =
    Number(form.values.noOfYears || 0) > 0 ||
    Number(form.values.noOfMonths || 0) > 0 ||
    Number(form.values.noOfDays || 0) > 0;

  const hasEndDate = !!form.values.dueDateOfContract;

  // Decide which section (Duration vs End Date) to show once, as soon as the
  // form actually has data (either freshly loaded for edit, or the user has
  // started a new contract). `inputMode` — not `hasDuration`/`hasEndDate` — is
  // the source of truth for what's rendered below, because those two derived
  // flags can legitimately both be true at once (duration entry also writes
  // a computed `dueDateOfContract` so it can be saved), which previously hid
  // both sections simultaneously with no way to recover.
  useEffect(() => {
    if (modeInitialized.current) return;
    if (!form.values.dateOfContract) return;

    modeInitialized.current = true;

    if (hasDuration) {
      setInputMode("duration");
    } else if (hasEndDate) {
      setInputMode("endDate");
    }
  }, [form.values.dateOfContract, hasDuration, hasEndDate]);

  const resetDuration = () => {
    form.setFieldValue("noOfYears", "0");
    form.setFieldValue("noOfMonths", "0");
    form.setFieldValue("noOfDays", "0");
    form.setFieldValue("dueDateOfContract", null);
    form.setFieldValue("contractTermInDays", 0);
    setInputMode(null);
  };

  // const calculateEndDateFromDuration = (startISO, years, months, days) => {
  //   if (!startISO) return null;
  //   let date = parseISO(startISO);
  //   if (years) date = addYears(date, Number(years));
  //   if (months) date = addMonths(date, Number(months));
  //   if (days) date = addDays(date, Number(days));
  //   return formatISO(date);
  // };

  const calculateEndDateFromDuration = (startISO, years, months, days) => {
    if (!startISO) return null;

    let date = parseISO(startISO);

    if (years) date = addYears(date, Number(years));
    if (months) date = addMonths(date, Number(months));
    if (days) date = addDays(date, Number(days));

    // subtract 1 day because contract ends one day before
    date = subDays(date, 1);

    return formatISO(date);
  };

  // const calculateDurationFromDates = (startISO, endISO) => {
  //   const start = parseISO(startISO);
  //   const end = parseISO(endISO);
  //   if (end <= start) return { years: "0", months: "0", days: "0" };
  //   const years = differenceInYears(end, start);
  //   const afterYears = addYears(start, years);
  //   const months = differenceInMonths(end, afterYears);
  //   const afterMonths = addMonths(afterYears, months);
  //   const days = differenceInDays(end, afterMonths);
  //   return {
  //     years: years.toString(),
  //     months: months.toString(),
  //     days: days.toString(),
  //   };
  // };
  const calculateDurationFromDates = (startISO, endISO) => {
    const start = parseISO(startISO);
    const end = parseISO(endISO);

    if (end < start) return { years: "0", months: "0", days: "0" };

    // add 1 day because duration includes start day
    const adjustedEnd = addDays(end, 1);

    const years = differenceInYears(adjustedEnd, start);
    const afterYears = addYears(start, years);

    const months = differenceInMonths(adjustedEnd, afterYears);
    const afterMonths = addMonths(afterYears, months);

    const days = differenceInDays(adjustedEnd, afterMonths);

    return {
      years: years.toString(),
      months: months.toString(),
      days: days.toString(),
    };
  };
  // const handleDurationChange = (field, value) => {
  //   form.setFieldValue(field, value);
  //   form.setFieldValue("dueDateOfContract", null);
  // };

  const handleDurationChange = (field, value) => {
    form.clearFieldError("noOfYears");
    form.clearFieldError("noOfMonths");
    form.clearFieldError("noOfDays");
    setInputMode("duration");

    form.setFieldValue(field, value);

    form.clearFieldError("dueDateOfContract");
    form.clearFieldError("noOfYears");
    form.clearFieldError("noOfMonths");
    form.clearFieldError("noOfDays");

    const years = field === "noOfYears" ? value : form.values.noOfYears;
    const months = field === "noOfMonths" ? value : form.values.noOfMonths;
    const days = field === "noOfDays" ? value : form.values.noOfDays;

    if (form.values.dateOfContract) {
      const endDate = calculateEndDateFromDuration(
        form.values.dateOfContract,
        years,
        months,
        days,
      );

      form.setFieldValue("dueDateOfContract", endDate);

      const start = parseISO(form.values.dateOfContract);
      const end = parseISO(endDate);

      const contractTermInDays = differenceInDays(end, start) + 1;

      form.setFieldValue("contractTermInDays", contractTermInDays);
    }
  };

  return (
    <div className="w-full flex flex-col my-4">
      <div className="w-full">
        <Group align="flex-start" spacing="md" mb="xl">
          <ThemeIcon variant="light" radius="xl" size={44}>
            <IconCalendarEvent size={20} />
          </ThemeIcon>

          <div>
            <Title order={4}>Contract Terms & Duration</Title>

            <Text size="sm" c="dimmed" style={{ textTransform: "none" }}>
              Configure contract validity, renewal and business information.
            </Text>
          </div>
        </Group>
        <hr></hr>

        <div
          className="grid grid-cols-1 lg:grid-cols-2 gap-x-8 gap-y-6"
          style={{ marginTop: "20px" }}
        >
          <DatePicker
            size="md"
            radius="md"
            required
            label="Start Date"
            placeholder="Select Start Sate"
            {...{
              ...form.getInputProps("dateOfContract"),
              onChange: (val) => {
                if (val && val.getTime) {
                  form.getInputProps("dateOfContract").onChange(formatISO(val));
                } else {
                  form.getInputProps("dateOfContract").onChange(null);
                }
                form.clearFieldError("dateOfContract");
              },
              value: form.values["dateOfContract"]
                ? parseISO(form.values.dateOfContract)
                : null,
            }}
            error={form.errors.dateOfContract}
            styles={fieldStyles}
          />

          {inputMode !== "endDate" && (
            <div>
              <div className="flex gap-3">
                <Select
                  size="md"
                  radius="md"
                  label="Duration"
                  placeholder="Years"
                  data={[
                    ...Array.from({ length: 11 }, (_, i) => ({
                      value: `${i}`,
                      label: `${i} Years`,
                    })),
                    { value: "100", label: "100 years" },
                  ]}
                  value={form.values.noOfYears}
                  onChange={(val) => handleDurationChange("noOfYears", val)}
                  styles={fieldStyles}
                  error={form.errors.noOfYears}
                />
                <Select
                  label="&nbsp;"
                  placeholder="Months"
                  data={[
                    ...Array.from({ length: 13 }, (_, i) => ({
                      value: `${i}`,
                      label: `${i} Months`,
                    })),
                  ]}
                  value={form.values.noOfMonths}
                  onChange={(val) => handleDurationChange("noOfMonths", val)}
                  size="md"
                  radius="md"
                  styles={fieldStyles}
                  error={form.errors.noOfMonths}
                />
                <Select
                  label="&nbsp;"
                  placeholder="Days"
                  data={[
                    ...Array.from({ length: 32 }, (_, i) => ({
                      value: `${i}`,
                      label: `${i} Days`,
                    })),
                  ]}
                  value={form.values.noOfDays}
                  onChange={(val) => handleDurationChange("noOfDays", val)}
                  size="md"
                  radius="md"
                  styles={fieldStyles}
                  error={form.errors.noOfDays}
                />
                <ActionIcon
                  variant="subtle"
                  color="red"
                  mt={30}
                  onClick={resetDuration}
                >
                  <IconReload size={16} />
                </ActionIcon>
              </div>
            </div>
          )}

          {/* END DATE SECTION: shown unless the user is actively entering a duration */}
          {inputMode !== "duration" && (
            <DatePicker
              size="md"
              radius="md"
              label="End Date"
              placeholder="Select End Date"
              onChange={(val) => {
                if (val && form.values.dateOfContract) {
                  setInputMode("endDate");

                  const endISO = formatISO(val);

                  const start = parseISO(form.values.dateOfContract);
                  const end = parseISO(endISO);

                  const contractTermInDays = differenceInDays(end, start) + 1;

                  form.setFieldValue("dueDateOfContract", endISO);
                  form.setFieldValue("contractTermInDays", contractTermInDays);

                  form.setFieldValue("noOfYears", "0");
                  form.setFieldValue("noOfMonths", "0");
                  form.setFieldValue("noOfDays", "0");
                } else {
                  resetDuration();
                  setInputMode(null);
                }
                form.clearFieldError("dueDateOfContract");
              }}
              value={
                form.values.dueDateOfContract
                  ? parseISO(form.values.dueDateOfContract)
                  : null
              }
              styles={fieldStyles}
              error={form.errors.dueDateOfContract}
            />
          )}
          <Select
            size="md"
            radius="md"
            placeholder="Reminder Duration"
            label="Renewal Reminder Duration (in days)"
            data={[
              { value: 15, label: reminderLabels["15"] },
              { value: 30, label: reminderLabels["30"] },
              { value: 45, label: reminderLabels["45"] },
              { value: 60, label: reminderLabels["60"] },
            ]}
            styles={fieldStyles}
            value={form.values.reminderTimeInDays}
            error={form.errors.reminderTimeInDays}
            onChange={(value) => {
              form.setFieldValue("reminderTimeInDays", value);
              form.clearFieldError("reminderTimeInDays");
            }}
          />
        </div>

        <div
          className="grid grid-cols-1 lg:grid-cols-2 gap-x-8 gap-y-6"
          style={{ marginTop: "20px" }}
        >
          <TextInput
            value={formatToIndianNumbering(agreementFormJson.agreementValue)}
            label="Annual Contract Value (₹)"
            placeholder="Enter Annual Contract Value"
            onChange={handleChange}
            size="md"
            radius="md"
            styles={fieldStyles}
          />
          {/* <Select
          style={{ marginBottom: "20px" }}
          required
          searchable
          placeholder="Enter location"
          label="Location"
          data={[...INDIA_STATES_UNIONS]}
          {...form.getInputProps("location")}
        /> */}
          <Select
            size="md"
            radius="md"
            required
            searchable
            placeholder="Select Business Unit"
            label="Business Unit"
            data={businessUnitsOptions}
            {...form.getInputProps("businessUnit")}
            dropdownPosition="bottom"
            styles={fieldStyles}
            onChange={(value) => {
              form.setFieldValue("businessUnit", value);
              form.clearFieldError("businessUnit");
            }}
          />
        </div>
        {/* <TextInput required label="Location" placeholder='Enter location' {...form.getInputProps('location')}/> */}
      </div>

      <div
        style={{
          marginTop: 40,
          paddingTop: 24,
          borderTop: "1px solid #E9ECEF",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
        }}
      >
        {uiConfigs.loading === loadingStates.LOADING ? (
          <BeatLoader color={colors.primary} size={10} />
        ) : (
          <>
            <Button onClick={savePrev} variant="outline" radius="md">
              Previous
            </Button>
            <Button onClick={saveNext} variant="contained" radius="md">
              Next →
            </Button>
          </>
        )}
      </div>
    </div>
  );
};

export default AgreementForm2;
